export type AppEnv = 'dev' | 'qa' | 'prod';

/**
 * Single source of truth for "which environment is this build".
 * Resolved from build-time signals only (no runtime network check):
 * - local vite dev server → 'dev'
 * - VITE_API_URL baked into the image → 'qa' | 'prod'
 * Fail-safe: a missing/unknown API URL resolves to 'prod' so an
 * environment marker can never accidentally ship to real users.
 */
export function getAppEnv(): AppEnv {
  if (import.meta.env.DEV) return 'dev';
  const api = import.meta.env.VITE_API_URL ?? '';
  if (api.includes('qa.racoreapp.com')) return 'qa';
  return 'prod';
}
